import styled from "styled-components";
import { primaryColor } from "../../config/constants";

export const Body = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div`
  margin-bottom: ${({ marginBottom }) => marginBottom && marginBottom};
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;
export const LogoImg = styled.img`
  height: 40%;
`;
export const OkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const WrongContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
export const CoachImg = styled.img`
  height: 192px;
`;
export const OkContainerInfo = styled.div`
  margin: 0 auto;
  padding: 32px 16px;
  width: 90%;
  max-width: 512px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: #fff;
`;
export const WrongContainerInfo = styled.div`
  margin: 0 auto;
  width: 80%;
  max-width: 512px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
`;
export const Title = styled.h1`
  color: #000;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
`;
export const Text = styled.p`
  color: #333;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
`;
export const DeepLink = styled.a`
  margin-top: 16px;
  padding: 12px 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${primaryColor};
  border: none;
  border-radius: 24px;
  outline: none;
  text-decoration: none;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
`;
